import React from "react";
import { Globe } from "lucide-react";
import { stats } from "../mock";
import Reveal from "./Reveal";

export default function GlobalReach() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden" style={{ background: "linear-gradient(135deg,#0a2a43,#0f3a5c)" }}>
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-10 left-10 h-64 w-64 rounded-full blur-3xl" style={{ background: "#00b4d8" }} />
        <div className="absolute bottom-0 right-10 h-72 w-72 rounded-full blur-3xl" style={{ background: "#0077b6" }} />
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative">
        <Reveal className="text-center max-w-2xl mx-auto mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 text-cyan-200 text-xs font-semibold mb-4">
            <Globe size={14} /> Global Presence
          </div>
          <p className="font-head font-semibold text-cyan-300 mb-1">Global Brilliance</p>
          <h2 className="font-head font-bold text-white text-3xl md:text-5xl mb-4">Local Excellence</h2>
          <p className="text-slate-300">
            Elevating businesses across 45+ nations. From the bustling markets of Asia Pacific
            and Africa to the serenity of Europe &mdash; our reach knows no bounds.
          </p>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((s, i) => (
            <Reveal key={s.label} delay={i * 90}>
              <div className="text-center rounded-2xl bg-white/5 border border-white/10 py-8 px-4 backdrop-blur-sm">
                <div className="font-head font-extrabold text-4xl md:text-5xl text-white mb-2">{s.value}</div>
                <div className="text-cyan-200 text-sm font-medium">{s.label}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
